import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { can, type Capability } from '@tilly/shared';
import { useBusinessStore } from '@/stores';
import { colors } from '@/theme/tokens';

interface RequireCapabilityProps {
  capability: Capability;
  children: ReactNode;
}

export function RequireCapability({ capability, children }: RequireCapabilityProps) {
  const activeRole = useBusinessStore((state) => state.activeRole);

  if (!activeRole) {
    return <Navigate to="/admin" replace />;
  }

  if (!can(activeRole, capability)) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          gap: 1,
          bgcolor: colors.bg,
          p: 3,
        }}
      >
        <Typography variant="h6">Access restricted</Typography>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Your role does not have permission to view this page.
        </Typography>
      </Box>
    );
  }

  return <>{children}</>;
}
